import InfoOutlined from '@mui/icons-material/InfoOutlined'
import CheckCircleOutlined from '@mui/icons-material/CheckCircleOutlined'
import WarningAmberOutlined from '@mui/icons-material/WarningAmberOutlined'
import ErrorOutlineOutlined from '@mui/icons-material/ErrorOutlineOutlined'
import { themeConfig } from '@gap/shared/theme'
import { GapAlertProps } from './GapAlert'
import { type NonUndefined } from '@gap/utils/utils'

interface GapAlertStoreProps {
   dark: boolean
   severity: GapAlertProps['severity']
   variant: NonUndefined<GapAlertProps['variant']>
}

type RampOption = 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900

export default class GapAlertStore {
   sp

   constructor(sp: GapAlertStoreProps) {
      this.sp = sp
   }

   /**
    * Normally every color uses the same ramp, but for info(yellow) we dont have a 'perfect' color setup and 200 is too dark.
    * A new browner color is being worked on, but for now, we catch it and manually set it to 100.
    */
   get lightRamp(): RampOption {
      switch (this.sp.severity) {
         case 'info':
            return 100
         case 'success':
         case 'warning':
         case 'error':
            return 200
      }
   }

   get ramp() {
      return {
         info: themeConfig.accents.yellow,
         success: themeConfig.system.success,
         warning: themeConfig.system.warning,
         error: themeConfig.system.error,
      }[this.sp.severity]
   }

   get Icon() {
      return {
         info: InfoOutlined,
         success: CheckCircleOutlined,
         warning: WarningAmberOutlined,
         error: ErrorOutlineOutlined,
      }[this.sp.severity]
   }

   get variantSx() {
      switch (this.sp.variant) {
         case 'filled':
            return {
               bgcolor: this.ramp[this.sp.dark ? 300 : 700],
               color: this.sp.dark ? this.ramp[900] : '#fff'
            }
         case 'standard':
            return {
               bgcolor: this.ramp[this.sp.dark ? 900 : this.lightRamp],
               color: this.ramp[this.sp.dark ? this.lightRamp : 900],
               border: `1px solid ${this.ramp[this.sp.dark ? 600 : 900]}`,
            }
         case 'outlined':
            return {
               bgcolor: this.sp.dark ? 'transparent' : '#fff',
               border: `1px solid ${this.ramp[this.sp.dark ? 400 : 700]}`,
               color: this.ramp[this.sp.dark ? this.lightRamp : 900],
            }
      }
   }
}
